var _g, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffc800",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 20,
    strokeDashoffset: 20,
    d: "M5 21V20C5 17.7909 6.79086 16 9 16H13C15.2091 16 17 17.7909 17 20V21"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    dur: "0.4s",
    values: "20;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 20,
    strokeDashoffset: 20,
    d: "M11 13C9.34315 13 8 11.6569 8 10C8 8.34315 9.34315 7 11 7C12.6569 7 14 8.34315 14 10C14 11.6569 12.6569 13 11 13Z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "0.5s",
    dur: "0.4s",
    values: "20;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 6,
    strokeDashoffset: 6,
    d: "M20 3V7"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "1s",
    dur: "0.2s",
    values: "6;0"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 11,
    r: 1,
    fill: "#ffc800",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "1.2s",
    dur: "0.4s",
    values: "0;1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPeopleIcon);
export default __webpack_public_path__ + "static/media/noPeopleIcon.8ef6048be075afbdf9295663467f0a01.svg";
export { ForwardRef as ReactComponent };